import { Subject } from 'rxjs'

export function RxJSUnsubscribe(constructor: Function) {
	if (!constructor.prototype?.ngOnDestroy) {
		throw new Error('Unsub decorator requires implementing of OnDestroy Interface')
	}

	if (!constructor.prototype?.getUnsubFromAllSubs) {
		throw new Error('Unsub decorator requires implementing of RxjsUnsubscribable interface')
	}

	constructor.prototype.getUnsubFromAllSubs = function() {
		const me = this as any;
		if (!me._unsubFromAllSubs) {
			me._unsubFromAllSubs = new Subject<boolean>();
		}

		return me._unsubFromAllSubs;
	}

	const ngOnDestroy = constructor.prototype.ngOnDestroy;
	constructor.prototype.ngOnDestroy = function() {
		if (this && this.getUnsubFromAllSubs()) {
			this.getUnsubFromAllSubs().next(true);
			this.getUnsubFromAllSubs().complete();
		}

		ngOnDestroy.apply(this);
	}
}